import antiSteeringWarnings from '../config/ml-care-anti-steering-warnings.json'

const defaultConfig = {
    warnings: antiSteeringWarnings.warnings
};
const config = Object.assign({}, defaultConfig);

export default {
    getAllDisclaimers: () => {
        return config.warnings;
    },
    getDisclaimer: (state) => {
        return config.warnings.find((item) => item.state === state) || config.warnings.find((item) => item.state === 'default');
    },
    getDefaultDisclaimer: () => {
        return config.warnings.find((item) => item.state === 'default');
    }
};